import type { AxiosInstance } from 'axios'
import type { TokenRefreshResponse, UserProfile } from './types'

export const AUTH_ENDPOINTS = {
  PROFILE: '/auth/user/profile/',
  TOKEN_REFRESH: '/auth/token/refresh/',
} as const

export const getProfile = async (client: AxiosInstance): Promise<UserProfile> => {
  const response = await client.get<UserProfile>(AUTH_ENDPOINTS.PROFILE)
  return response.data
}

export const patchProfile = async (client: AxiosInstance, profile: Partial<UserProfile>): Promise<UserProfile> => {
  const response = await client.patch<UserProfile>(AUTH_ENDPOINTS.PROFILE, profile)
  return response.data
}

export const putProfile = async (client: AxiosInstance, profile: UserProfile): Promise<UserProfile> => {
  const response = await client.put<UserProfile>(AUTH_ENDPOINTS.PROFILE, profile)
  return response.data
}

export const refreshToken = async (client: AxiosInstance, refreshToken: string): Promise<TokenRefreshResponse> => {
  const response = await client.post<TokenRefreshResponse>(AUTH_ENDPOINTS.TOKEN_REFRESH, {
    refresh: refreshToken,
  })
  return response.data
}

export const deleteProfile = async (client: AxiosInstance): Promise<{ message: string }> => {
  const response = await client.delete<{ message: string }>(AUTH_ENDPOINTS.PROFILE)
  return response.data
}

export const clearAppState = (queryClient: any, resetFunctions: (() => void)[]) => {
  if (queryClient && typeof queryClient.clear === 'function') {
    queryClient.clear()
  }
  for (const reset of resetFunctions) {
    try {
      reset()
    } catch (error) {
      console.error('Failed to reset store:', error)
    }
  }
}
